import { Theme } from '@mui/material';

export const statusTransaction = {
    SUCCESS: 'success',
    PENDING: 'pending',
    FAILED: 'failed'
};

export const statusUser = {
    ENABLED: 1,
    DISABLED: 0
};

export const statusLog = {
    SUCCESS: 1,
    FAILED: 0
};

export const statusApiKeyUser = {
    ENABLED: true,
    DISABLED: false
};

export const displayStatusUser = (status: boolean, theme: any) => {
    const propStatus = {
        text: '',
        color: ''
    };
    switch (status) {
        case statusApiKeyUser.ENABLED:
            propStatus.text = 'Enabled';
            propStatus.color = theme.palette.success.main;
            break;

        case statusApiKeyUser.DISABLED:
            propStatus.text = 'Disabled';
            propStatus.color = theme.palette.error.main;

            break;

        default:
            break;
    }
    return propStatus;
};

const getStatusUser = (status: string | undefined) => {
    let statusNumber;

    if ((status && status === 'Disabled') || status === 'Enabled') {
        switch (status) {
            case 'Disabled':
                statusNumber = statusUser.DISABLED;
                break;
            case 'Enabled':
                statusNumber = statusUser.ENABLED;
                break;

            default:
                break;
        }
        return statusNumber;
    }
    return status;
};

export const displayStatusTransactions = (status: string, theme: Theme) => {
    let color;
    switch (status) {
        case statusTransaction.SUCCESS:
            color = theme.palette.success.main;
            break;
        case statusTransaction.PENDING:
            color = theme.palette.warning.dark;
            break;
        case statusTransaction.FAILED:
            color = theme.palette.error.main;
            break;
        default:
            break;
    }
    return color;
};

export const displayStatusTransactionsDetail = (status: string, theme: Theme) => {
    let color = theme.palette.success.main;
    let backgroundColor = theme.palette.success.light;
    switch (status) {
        case statusTransaction.SUCCESS:
            color = theme.palette.success.main;
            backgroundColor = theme.palette.success.light;
            break;
        case statusTransaction.PENDING:
            color = theme.palette.warning.dark;
            backgroundColor = theme.palette.warning.light;

            break;
        case statusTransaction.FAILED:
            color = theme.palette.error.main;
            backgroundColor = theme.palette.error.light;

            break;
        default:
            break;
    }
    return { color, backgroundColor };
};

export const displayStatusLog = (status: number, theme: Theme) => {
    let color = theme.palette.success.main;
    let backgroundColor = theme.palette.success.light;
    let content = 'Success';
    switch (status) {
        case statusLog.SUCCESS:
            color = theme.palette.success.main;
            backgroundColor = theme.palette.success.light;
            content = 'Success';
            break;

        case statusLog.FAILED:
            color = theme.palette.error.main;
            backgroundColor = theme.palette.error.light;
            content = 'Failed';

            break;
        default:
            break;
    }
    return { color, backgroundColor, content };
};

export default getStatusUser;
